import { z } from "zod";

/**
 * Avatar via Data URL base64 (MVP — migrar pra R2 depois).
 * Limite: ~2MB binário => ~2.8MB base64.
 */
export const MAX_AVATAR_DATA_URL_LENGTH = 2_800_000;
export const MAX_AVATAR_BINARY_BYTES = 2_000_000;

export const updateAvatarSchema = z.object({
  dataUrl: z
    .string()
    .startsWith("data:image/", "Formato inválido (esperado data:image/*)")
    .max(MAX_AVATAR_DATA_URL_LENGTH, "Imagem muito grande (máx ~2MB)"),
});

export type UpdateAvatarInput = z.infer<typeof updateAvatarSchema>;
